import {enableProdMode, ViewEncapsulation} from '@angular/core';
import {platformBrowserDynamic} from '@angular/platform-browser-dynamic';
import {AppModule} from './app.module';
import {Config} from '@synisys/idm-ui-shell/app/config';
import {SpeedDetectorService} from './service/speed-detector.service';
import {Yggdrasil} from '@synisys/yggdrasil';


if (process.env.NODE_ENV === 'production') {
	enableProdMode();
}

// detect speed of the user's internet connection
new SpeedDetectorService().detectSpeed();

// bootstrap Yggdrasil
void Yggdrasil.bootstrap({
	scriptUrl: './worker.js?v=' + window['version'],
	hostUrl: window.location.origin,
	deployContext: document.baseURI.replace(location.origin, ''),
	routeNavigator: {
		navigateTo: (url: string) => {
			// window.history.pushState({}, '', url);
		}
	},
	rootPages: []
}).then(
	() => {
		console.log('Yggdrasil started');
		window.dispatchEvent(
			new CustomEvent('yggdrasil-started', {
				detail: {
					yggdrasil: window.yggdrasil
				}
			})
		);

		// bootstrap the application
		return platformBrowserDynamic([
			{provide: 'imagesPath', useValue: './static/images'},
			{provide: 'configPath', useValue: './static/configs'},
			{provide: Config.coreConfigPathToken, useValue: './static/configs'}
		]).bootstrapModule(
			AppModule,
			[{defaultEncapsulation: ViewEncapsulation.None}]
		);
	},
	error => {
		console.error(error);
	}
);
